<template>
  <div class="avatar">
    <input type="file" id="avatar" accept="image/x-png,image/jpeg" capture @change="onFileChanged">
    <label for="avatar" :style="{backgroundImage: `url(${thumbnail})`}">
      <RoundProgress :progress="uploading" />
      <p v-if="!thumbnail">Velg profil bilde</p>
    </label>
  </div>
</template>

<script>
import { uploadFile } from '@/fire'
import RoundProgress from '@/components/RoundProgress.vue'

export default {
  props: {
    value: String,
  },
  data () {
    return {
      thumbnail: this.value || '',
      uploading: 0,
    }
  },
  computed: {
    authUser () {
      return this.$store.state.user.authUser
    },
  },
  watch: {
    value (val) {
      this.thumbnail = val || ''
    },
  },
  methods: {
    onFileChanged (event) {
      this.uploading = 0
      this.error = ''
      if (event.target.files && event.target.files.length) {
        const file = event.target.files[0]
        if (this.isValidImage(file)) {
          if (file && window.FileReader) {
            const reader = new FileReader()
            this.thumbnail = ''
            reader.onloadend = () => {
              this.thumbnail = reader.result
            }
            reader.readAsDataURL(file)
          }

          const ext = file.type.slice(6)
          uploadFile(`${this.authUser.uid}/new-avatar.${ext}`, file, (url) => {
            this.thumbnail = url
            this.$emit('input', url)
            this.uploading = 0
          }, (error) => {
            console.warn(error)
            this.uploading = 0
          }, (progress) => {
            this.uploading = Math.ceil(progress * 100)
          }, {
            uid: this.authUser.uid,
          })
        }
      }
    },
    isValidImage (file) {
      if (!file) return false
      const isImage = /image\/(jpg|jpeg|png)$/i
      const isLt2M = file.size / 1024 / 1024 < 16

      if (!(isImage).test(file.type)) {
        this.$emit('error', 'Bildet må være av typen jpg | jpeg | png')
      }
      if (!isLt2M) {
        this.$emit('error', 'Bildestørrelsen kan ikke overstige 16mb')
      }
      return isImage && isLt2M
    },
  },
  components: {
    RoundProgress,
  },
}
</script>

<style lang="scss">
.avatar {
  display: block;
  width: 100px;
  height: 100px;
  margin: 24px auto;

  input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  input + label {
    position: relative;
    text-align: center;
    font-size: 14rem;
    font-weight: 700;
    color: white;
    background-color: var(--dark);
    background-position: center;
    background-size: cover;
    display: inline-block;
    width: 100%;
    height: 100%;
    margin: 0 auto;

    &>p {
      height: 100%;
      margin: 0;
      display: table-cell;
      vertical-align: middle;
    }
  }


  input:focus + label,
  input + label:hover {
    background-color: var(--primary);
  }
}
</style>
